import FloatingCourseActionsBar from '@/components/FloatingCourseActionsBar';
import GoBackMenu from '@/components/GoBackNavbar';
import Tab from '@/components/Tab';
import { ApplicationState } from '@/store';
import { getLessonClear } from '@/store/lesson/action';
import { getCourseClear } from '@/store/list/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Switch, useHistory, useParams } from 'react-router-dom';
import CourseInfo from './Info';
import CourseLessons from './Lessons';
import './style.scss';

const ManageCourse: React.FC = () => {
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const LMSPath = '/contents/lms/courses';

    useEffect(() => {
        return () => {
            dispatch(getCourseClear());
            dispatch(getLessonClear());
        };
    }, []);

    return (
        <>
            <div className="create-course">
                <GoBackMenu confirmable goBackPath={LMSPath} />
                <div className="title">
                    <h1>{id ? strings.EDIT_COURSE : strings.NEW_COURSE}</h1>
                </div>
                <div className="create-course__container">
                    <div className="tabs-container">
                        <Tab
                            active={!history.location.pathname.match(/(lessons)/)}
                            setActive={() => id && history.push(`${LMSPath}/${id}`)}
                            title={strings.GENERAL_INFORMATION}
                        />
                        <Tab
                            active={history.location.pathname.indexOf('lessons') > -1}
                            disabled={!id}
                            setActive={() => id && history.push(`${LMSPath}/${id}/lessons`)}
                            title={strings.LESSONS}
                        />
                    </div>

                    <div className="course-content">
                        <Switch>
                            <Route exact path={`${LMSPath}/:id`}>
                                <CourseInfo />
                            </Route>
                            <Route exact path={`${LMSPath}/:id/lessons`}>
                                <CourseLessons />
                            </Route>
                            <Route exact path={LMSPath}>
                                <CourseInfo />
                            </Route>
                        </Switch>
                    </div>
                </div>
                <FloatingCourseActionsBar />
            </div>
        </>
    );
};

export default ManageCourse;
